/* ==========================================================================
   Lumen — section-product-recommendations.js
   Deferred loader for the product-recommendations section. Waits until the
   [data-product-recommendations] shell nears the viewport, fetches the
   Shopify recommendations endpoint (data-url), and swaps in the rendered
   grid. Injected .reveal elements are shown manually because the core
   reveal observer only watches nodes present at page load.
   ========================================================================== */
(function () {
  'use strict';

  function showReveals(scope) {
    var els = scope.querySelectorAll('.reveal');
    Array.prototype.forEach.call(els, function (el, i) {
      if (!el.style.transitionDelay) el.style.transitionDelay = (i * 80) + 'ms';
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        Array.prototype.forEach.call(els, function (el) {
          el.classList.add('is-visible');
        });
      });
    });
  }

  function load(el) {
    if (el.getAttribute('data-loaded') === 'true') return;
    el.setAttribute('data-loaded', 'true');
    var url = el.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-product-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
          showReveals(el);
        }
      })
      .catch(function () {
        /* Recommendations are an enhancement — fail silently. */
        el.removeAttribute('data-loaded');
      });
  }

  function init(el) {
    if (el.getAttribute('data-observed') === 'true') return;
    el.setAttribute('data-observed', 'true');

    if (!('IntersectionObserver' in window)) {
      load(el);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.disconnect();
        load(el);
      });
    }, { rootMargin: '0px 0px 400px 0px' });
    io.observe(el);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-product-recommendations]');
    Array.prototype.forEach.call(nodes, init);
  }

  initAll(document);

  /* Theme editor: section re-renders replace the shell. */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
